/* eslint-disable flowtype/no-types-missing-file-annotation */
/* eslint-disable react/prop-types */

import { Button } from '@material-ui/core'
import React from 'react'
import './buttonstyles.scss'
var classNames = require('classnames')

export const FlatFormSubmitButton = ({ children, disabled = false }) => {
  return (
    <Button className="text-body button flat white" disabled={disabled} style={{ textTransform: 'none', color: 'white' }} type="submit">
      {children}
    </Button>
  )
}
